import { render, staticRenderFns } from "./baseSearch.vue?vue&type=template&id=8fa5d3fa"
import script from "./baseSearch.vue?vue&type=script&lang=js"
export * from "./baseSearch.vue?vue&type=script&lang=js"
import style0 from "./baseSearch.vue?vue&type=style&index=0&id=8fa5d3fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports